import { Box, Typography } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@/components/ui/table";

interface KeyValueDetailsProps {
  properties: {
    [key: string]: any;
  };
  countText: string;
  header: string;
}

export const KeyValueDetails = (props: KeyValueDetailsProps) => {
  return (
    <Box width="100%">
      <Typography variant="body1">{props.countText}</Typography>
      <Typography variant="h6">{props.header}</Typography>
      <Table>
        <TableBody>
          {Object.keys(props.properties).map((key) => (
            <TableRow key={key}>
              <TableCell className="p-1 text-left">{key}</TableCell>
              <TableCell className="p-1 text-left">
                {props.properties[key]
                  ? props.properties[key].toString()
                  : ""}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};
